import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiSyncLogService from "services/ApiSyncLogService";

export const getApiSyncLogs = createAsyncThunk(
  "apiSyncLog/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ApiSyncLogService.getAll(params);
      return {
        data: response.data?.data || [],
        totalCount: response.data?.totalCount || 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || "Error");
    }
  }
);

export const getLatestApiSyncLogs = createAsyncThunk(
  "apiSyncLog/getLatest",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ApiSyncLogService.getLatestSync(params);
      return {
        data: response.data?.logs || [],
        totalCount: response.data?.totalRecords || 0,
        latestCreatedTime: response.data?.latestSyncTime || null,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  latestLoading: false,

  syncLogs: [],
  totalCount: 0,

  latestSyncLogs: [],
  latestTotalCount: 0,
  latestCreatedTime: null,

  error: null,
};

export const apiSyncLogSlice = createSlice({
  name: "apiSyncLog",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    clearLatestSyncData: (state) => {
      state.latestSyncLogs = [];
      state.latestTotalCount = 0;
      state.latestCreatedTime = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApiSyncLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getApiSyncLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.syncLogs = action.payload.data;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getApiSyncLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getLatestApiSyncLogs.pending, (state) => {
        state.latestLoading = true;
        state.error = null;
      })
      .addCase(getLatestApiSyncLogs.fulfilled, (state, action) => {
        state.latestLoading = false;
        state.latestSyncLogs = action.payload.data;
        state.latestTotalCount = action.payload.totalCount;
        state.latestCreatedTime = action.payload.latestCreatedTime;
      })
      .addCase(getLatestApiSyncLogs.rejected, (state, action) => {
        state.latestLoading = false;
        state.error = action.payload;
      });
  },
});

export const { showLoading, clearLatestSyncData } =
  apiSyncLogSlice.actions;

export default apiSyncLogSlice.reducer;